<template>
  <v-container>
    <v-dialog v-model="showAlertError" persistent width="500">
      <v-card>
        <v-card-title class="headline red accent-4" primary-title>
          {{ $t('estadisticas.error') }}
        </v-card-title>
        <v-card-text>
          {{ mensajeError }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="showAlertError = false">
            {{ $t('estadisticas.aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="showLoadingPresupuestos && showLoadingCompras">
      <v-progress-linear
        color="blue-grey lighten-4"
        indeterminate
        rounded
        height="6"
        class="my-8"
      />
    </div>
    <!-- Se muesta el contenido del componente -->
    <div v-else>
      <v-row>
        <v-col>
          <v-card>
            <v-card-subtitle class="font-weight-bold blue darken-1">
              {{ $t('estadisticas.ultimos30Dias') }}
            </v-card-subtitle>
            <v-container v-if="showLoadingPresupuestos">
              <v-row
                class="fill-height my-8"
                align-content="center"
                justify="center"
              >
                <v-col cols="6">
                  <v-progress-circular
                    indeterminate
                    color="blue lighten-4"
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </v-container>
            <v-simple-table v-else dense>
              <template v-slot:default>
                <thead>
                  <tr class="text-uppercase">
                    <th class="text-left font-weight-bold text-subtitle-2">
                      {{ $t('estadisticas.presupuestos') }}
                    </th>
                    <th class="text-center font-weight-bold text-subtitle-2">
                      {{ $t('estadisticas.cantidad') }}
                    </th>
                    <th class="text-right font-weight-bold text-subtitle-1">
                      {{ $t('estadisticas.signoPorcentaje') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="blue lighten-5">
                    <td class="text-left">
                      {{ $t('estadisticas.recibidos') }}
                    </td>
                    <td>{{ presupuestos.recibidos }}</td>
                    <td class="text-right">
                      {{ $t('estadisticas.100Porciento') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      {{ $t('estadisticas.respondidos') }}
                    </td>
                    <td>{{ presupuestos.respondidos }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.respondidos,
                          presupuestos.recibidos
                        )
                      }}%
                    </td>
                  </tr>
                  <tr class="blue lighten-5">
                    <td class="pl-8 text-left">
                      {{ $t('estadisticas.sinDisponibilidad') }}
                    </td>
                    <td>{{ presupuestos.respondidos_sin_disponibilidad }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.respondidos_sin_disponibilidad,
                          presupuestos.respondidos
                        )
                      }}%
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-8 text-left">
                      {{ $t('estadisticas.conDisponibilidad') }}
                    </td>
                    <td>{{ presupuestos.respondidos_con_disponibilidad }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.respondidos_con_disponibilidad,
                          presupuestos.respondidos
                        )
                      }}{{ $t('estadisticas.signoPorcentaje') }}
                    </td>
                  </tr>
                  <tr class="blue lighten-5">
                    <td class="pl-12 text-left">
                      {{ $t('estadisticas.ganados') }}
                    </td>
                    <td>
                      {{ presupuestos.respondidos_ganados }}
                    </td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.respondidos_ganados,
                          presupuestos.respondidos
                        )
                      }}%
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">
                      {{ $t('estadisticas.pendientes') }}
                    </td>
                    <td>{{ presupuestos.sin_responder_pendientes }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.sin_responder_pendientes,
                          presupuestos.recibidos
                        )
                      }}{{ $t('estadisticas.signoPorcentaje') }}
                    </td>
                  </tr>
                  <tr class="blue lighten-5">
                    <td class="text-left">{{ $t('estadisticas.vencidos') }}</td>
                    <td>{{ presupuestos.sin_responder_vencidos }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          presupuestos.sin_responder_vencidos,
                          presupuestos.recibidos
                        )
                      }}{{ $t('estadisticas.signoPorcentaje') }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>{{ $t('estadisticas.tiempoPromedioRespuesta') }}</td>
                    <td colspan="2">{{ tiempoPromedioDeRespuesta }}</td>
                  </tr>
                </tfoot>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-subtitle class="font-weight-bold green darken-1">
              {{ $t('estadisticas.ultimos30Dias') }}
            </v-card-subtitle>
            <v-container v-if="showLoadingCompras">
              <v-row
                class="fill-height my-8"
                align-content="center"
                justify="center"
              >
                <v-col cols="6">
                  <v-progress-circular
                    indeterminate
                    color="green lighten-4"
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </v-container>
            <v-simple-table v-else dense>
              <template v-slot:default>
                <thead>
                  <tr class="text-uppercase">
                    <th class="text-left font-weight-bold text-subtitle-2">
                      {{ $t('estadisticas.compras') }}
                    </th>
                    <th class="text-center font-weight-bold text-subtitle-2">
                      {{ $t('estadisticas.cantidad') }}
                    </th>
                    <th class="text-right font-weight-bold text-subtitle-1">
                      {{ $t('estadisticas.signoPorcentaje') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="green lighten-5">
                    <td class="text-left">
                      {{ $t('estadisticas.recibidas') }}
                    </td>
                    <td>{{ compras.compras_recibidas }}</td>
                    <td class="text-right">
                      {{ $t('estadisticas.100Porciento') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="pl-8 text-left">
                      {{ $t('estadisticas.documentacionCargada') }}
                    </td>
                    <td>{{ compras.compras_doc_cargada }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          compras.compras_doc_cargada,
                          compras.compras_recibidas
                        )
                      }}{{ $t('estadisticas.signoPorcentaje') }}
                    </td>
                  </tr>
                  <tr class="green lighten-5">
                    <td class="pl-8 text-left">
                      {{ $t('estadisticas.pendiente') }}
                    </td>
                    <td>{{ compras.compras_doc_pendiente }}</td>
                    <td class="text-right">
                      {{
                        calcularPorcentaje(
                          compras.compras_doc_pendiente,
                          compras.compras_recibidas
                        )
                      }}%
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import servicePresupuesto from '~/services/servicePresupuesto'
import serviceOrdenCompra from '~/services/serviceOrdenCompra'

export default {
  name: 'Estadisticas',
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showLoadingPresupuestos: false,
      showLoadingCompras: false,
      presupuestos: [],
      compras: [],
      fechaInicial: null,
      fechaFinal: null,
      mensajeError: '',
      showAlertError: false
    }
  },
  computed: {
    tiempoPromedioDeRespuesta() {
      return this.convertirAHoras()
    }
  },
  beforeCreate() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - BEFORE CREATE')
  },
  created() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - CREATED')
    // eslint-disable-next-line no-console
    console.log('  - user prop:', this.user)
    // eslint-disable-next-line no-console
    console.log('  - $route.query:', this.$route.query)

    this.fechaInicial = new Date()
    this.fechaFinal = new Date()
    this.fechaInicial.setDate(this.fechaInicial.getDate() - 31)

    // eslint-disable-next-line no-console
    console.log('  - Llamando getPresupuestosEstadisticas()')
    this.getPresupuestosEstadisticas()

    // eslint-disable-next-line no-console
    console.log('  - Llamando getComprasEstadisticas()')
    this.getComprasEstadisticas()
  },
  beforeMount() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - BEFORE MOUNT')
  },
  mounted() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - MOUNTED')
    // eslint-disable-next-line no-console
    console.log('  - $route.query:', this.$route.query)
  },
  beforeUpdate() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - BEFORE UPDATE')
  },
  updated() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - UPDATED')
  },
  beforeDestroy() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - BEFORE DESTROY')
  },
  destroyed() {
    // eslint-disable-next-line no-console
    console.log('📊 ESTADISTICAS - DESTROYED')
  },
  methods: {
    async getPresupuestosEstadisticas() {
      // eslint-disable-next-line no-console
      console.log('📊 ESTADISTICAS - getPresupuestosEstadisticas() INICIANDO')

      this.showLoadingPresupuestos = true
      const payload = {
        tipo: 2,
        desde: this.fechaInicial.toISOString().slice(0, 10),
        hasta: this.fechaFinal.toISOString().slice(0, 10)
      }

      // eslint-disable-next-line no-console
      console.log('  - payload:', payload)

      await servicePresupuesto
        .estadisticas(this.$config.axiosParams, payload)
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log('📊 ESTADISTICAS - getPresupuestosEstadisticas() SUCCESS')
          // eslint-disable-next-line no-console
          console.log('  - response.data:', response.data)

          this.showLoadingPresupuestos = false
          this.presupuestos = response.data
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('📊 ESTADISTICAS - getPresupuestosEstadisticas() ERROR')
          // eslint-disable-next-line no-console
          console.log('  - error:', error)
          // eslint-disable-next-line no-console
          console.log('  - error.response?.status:', error?.response?.status)

          if (error?.response?.status === 401) {
            // eslint-disable-next-line no-console
            console.log('  - Redirigiendo a /login')
            this.$router.push('/login')
          } else {
            this.showLoadingPresupuestos = false
            this.mensajeError = `Error al obtener la estadística de los presupuestos. ${error}`
            this.showAlertError = true
          }
        })
    },
    async getComprasEstadisticas() {
      // eslint-disable-next-line no-console
      console.log('📊 ESTADISTICAS - getComprasEstadisticas() INICIANDO')

      this.showLoadingCompras = true
      const busqueda = {
        desde: this.fechaInicial.toISOString().slice(0, 10),
        hasta: this.fechaFinal.toISOString().slice(0, 10)
      }

      // eslint-disable-next-line no-console
      console.log('  - busqueda:', busqueda)

      try {
        const response = await serviceOrdenCompra.estadisticas(
          this.$config.axiosParams,
          busqueda
        )

        // eslint-disable-next-line no-console
        console.log('📊 ESTADISTICAS - getComprasEstadisticas() SUCCESS')
        // eslint-disable-next-line no-console
        console.log('  - response.data:', response.data)

        this.compras = response.data
        this.showLoadingCompras = false
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('📊 ESTADISTICAS - getComprasEstadisticas() ERROR')
        // eslint-disable-next-line no-console
        console.log('  - error:', error)
        // eslint-disable-next-line no-console
        console.log('  - error.response?.status:', error?.response?.status)

        if (error?.response?.status === 401) {
          // eslint-disable-next-line no-console
          console.log('  - Redirigiendo a /login')
          this.$router.push('/login')
        } else {
          this.showLoadingCompras = false
          this.mensajeError = `Error al obtener la estadística para las compras. ${error}`
          this.showAlertError = true
        }
      }
    },
    calcularPorcentaje(parcial, total) {
      if (total === 0) {
        return ''
      }
      const porcentaje = (parcial / total) * 100
      if (Number.isInteger(porcentaje)) {
        return porcentaje
      }
      return Math.round(porcentaje)
    },
    convertirAHoras() {
      if (
        typeof this.presupuestos.respondidos_promedio_respuesta === 'undefined'
      ) {
        return ''
      }
      const minutosTranscurridos = Math.trunc(
        this.presupuestos.respondidos_promedio_respuesta
      )
      if (minutosTranscurridos > 60) {
        const horas = Math.floor(minutosTranscurridos / 60)
        const minutos = minutosTranscurridos % 60

        return minutos > 0 ? `${horas}h ${minutos}m` : `${horas}h`
      }
      return `${minutosTranscurridos}m`
    }
  }
}
</script>

<style lang="scss">
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
